import { registerDe } from '../i18n/index.js';

registerDe({
  // ── the stream ──
  'Nothing logged here yet. A meeting, a call, a mail, a note — every touchpoint with provenance becomes a row.':
    'Hier ist noch nichts erfasst. Ein Treffen, ein Anruf, eine Mail, eine Notiz — jeder Kontakt mit Herkunftsnachweis wird zu einer Zeile.',
  'Date not confirmed': 'Datum nicht bestätigt',
  'Mail in': 'E-Mail ein',
  'Mail out': 'E-Mail aus',
  'Meeting': 'Treffen',
  'Call': 'Anruf',
  'Note': 'Notiz',
  'Post': 'Beitrag',
  'Signal': 'Signal',

  // ── log a touchpoint ──
  'Log a touchpoint': 'Kontakt erfassen',
  'Kind': 'Art',
  'Date': 'Datum',
  'Title': 'Titel',
  'What happened, in a few words': 'Was geschah, in wenigen Worten',
  'Summary': 'Zusammenfassung',
  'Organisation': 'Organisation',
  'Search organisations': 'Organisationen suchen',
  'Participants': 'Teilnehmende',
  'Search people, or type a name and add it': 'Personen suchen oder einen Namen eingeben und hinzufügen',
  'Add "{name}" as a name, not yet a person': '„{name}“ als Namen hinzufügen, noch keine Person',
  'Touchpoint logged.': 'Kontakt erfasst.',
  'Could not save the touchpoint.': 'Kontakt konnte nicht gespeichert werden.',
}, 'Timeline');
